import { BaseDto } from './base.dto';
import { CostCentreDto } from './costCentre.dto';
import { DepartmentDto } from './department.dto';
import { GenderDto } from './gender.dto';
import { GiftCardDto } from './gift-card';
import { HonorificTitleDto } from './honorificTitle.dto';
import { JobTitleDto } from './jobTitle.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantGroupDto } from './merchantGroup.dto';
import { OrderPosTableInfoDto } from './orderPOSTableInfo.dto';
import { PriceBracketDto } from './priceBracket.dto';
import { UserDto } from './user.dto';

export class EmployeeDto extends BaseDto {
  id: number;
  employeeNumber?: string;
  firstName: string;
  lastName?: string;
  personalEmail: string;
  userId?: number;
  honorificTitleId?: number;
  merchantId?: number;
  departmentId?: number;
  jobTitleId?: number;
  merchant?: MerchantDto;
  department?: DepartmentDto;
  genderId?: number;
  costCentreId?: number;
  user?: UserDto;
  startDate: Date;
  endDate?: Date;
  isActive?: boolean;
  knownAs: string;
  imageUrl?: string;
  honorificTitle?: HonorificTitleDto;
  gender?: GenderDto;
  jobTitle?: JobTitleDto;
  merchantGroupId: number;
  merchantGroup?: MerchantGroupDto;
  costCentre?: CostCentreDto;
  activeByDate?: boolean;
  isManagementAccess?: boolean;
  posAccessPin?: string;
  isOperatorAccess?: boolean;
  managerAccessPin?: string;
  orderPosTableInfos?: OrderPosTableInfoDto[] | null;
  additionalCostCentres?: CostCentreDto[];
  priceBracket?: PriceBracketDto;
  giftCardId?: number;
  giftCard?: GiftCardDto;
}
